import { CategoriesResponse, Owner } from "@accurx/api/content";
import { Log, httpClient2 } from "@accurx/shared";
import { useQuery } from "@tanstack/react-query";

export const useTemplateCategories = (workspaceId: number, owner: Owner) =>
    useQuery({
        queryKey: ["GetTemplateCategories", { workspaceId, owner }],
        queryFn: async () => {
            if (!workspaceId) {
                Log.error("Could not fetch categories: missing workspace id");
                throw new Error(
                    "Could not fetch categories: missing workspace id",
                );
            }
            if (owner !== Owner.User && owner !== Owner.Workspace) {
                Log.error("Owner must be User or Workspace for this request");
                return;
            }
            return await httpClient2
                .get({
                    path: "/api/content/workspace/:workspaceId/templates/category",
                    params: {
                        workspaceId: workspaceId.toString(),
                    },
                    query: `?owner=${owner}`,
                })
                .json<CategoriesResponse>();
        },
        refetchOnMount: true,
    });
